// extracted by mini-css-extract-plugin
export default {"folder":"OpenerIcon__folder___jiKx6","folderDown":"OpenerIcon__folderDown___fPk9H"};